export function getHoverStack(state) {
    return state.hoverStack;
}
export function isHovering(state) {
    return state.hoverStack.length > 0;
}
